import { combineReducers, type Reducer } from 'redux';

import { appReducer } from '../app/redux/App.reducers';
import { langReducer } from '../configuration/lang/reducer';
import { loginReducer } from '../configuration/login/reducer';
import { configReducer } from '../configuration/setup/configReducer';
import { tokenHandlingReducer } from '../configuration/tokenHandling/reducer';
import { onboardingReducer } from '../onboarding/redux/onboarding.redux';
import { apiReducer } from './api/api.redux';
import { assetTreeReducer } from './assettree/assetTree.redux';
import { dataReducer } from './data/data.redux';
import { domainReducer } from './domain/domain.redux';
import { historyTableReducer } from './historytable/historyTable.redux';
import { positionSharingReducer } from './positionsharing/positionSharing.redux';
import { sidebarMapReducer } from './sidebarmap/sidebarMap.redux';
import { widgetReducer } from './widget/widget.redux';

export const rootReducer = (): Reducer =>
    combineReducers({
        api: apiReducer,
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        data: dataReducer,
        login: loginReducer,
        tokenHandling: tokenHandlingReducer,
        assetTree: assetTreeReducer,
        historyTable: historyTableReducer,
        sidebarMap: sidebarMapReducer,
        positionSharing: positionSharingReducer,
        widget: widgetReducer,
        onboarding: onboardingReducer,
        domain: domainReducer,
    });

const tmp = rootReducer();
export type State = ReturnType<typeof tmp>;
